var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCortex(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81641 16.5C6.69467 16.5 4.65984 15.6571 3.15955 14.1569C1.65926 12.6566 0.816406 10.6217 0.816406 8.5C0.816406 6.37827 1.65926 4.34344 3.15955 2.84315C4.65984 1.34285 6.69467 0.5 8.81641 0.5V3.94435C7.60817 3.94435 6.44942 4.42432 5.59507 5.27867C4.74072 6.13302 4.26075 7.29177 4.26075 8.5C4.26075 9.70823 4.74072 10.867 5.59507 11.7213C6.44942 12.5757 7.60817 13.0557 8.81641 13.0557L8.81641 16.5Z",
    fill: "#00CC66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.81562 3.96094C9.4116 3.96094 10.0017 4.07832 10.5523 4.30639C11.103 4.53446 11.6033 4.86875 12.0247 5.29017C12.4461 5.71159 12.7804 6.21189 13.0084 6.7625C13.2365 7.31311 13.3539 7.90325 13.3539 8.49922C13.3539 9.0952 13.2365 9.68534 13.0084 10.2359C12.7804 10.7866 12.4461 11.2869 12.0247 11.7083C11.6032 12.1297 11.1029 12.464 10.5523 12.692C10.0017 12.9201 9.41159 13.0375 8.81561 13.0375L8.81562 8.49922V3.96094Z",
    fill: "#00CC66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCortex);
export default __webpack_public_path__ + "static/media/Cortex.714a7967d0f022cc044b3734c0a260a4.svg";
export { ForwardRef as ReactComponent };